// Réglage local des textes de fin de série.
//
// Vit dans son propre module, et non dans le composant : le hook de tirage doit
// savoir s'il faut demander un texte AVANT d'en afficher un, et le panneau de
// compte doit pouvoir les réactiver. Faire importer un composant React par un
// hook pour deux lignes de localStorage était le mauvais sens de dépendance.
//
// Le réglage est PAR NAVIGATEUR, comme le son et la cursive. Il ne suit pas le
// compte : c'est un réglage de confort de lecture, pas une donnée de progression.
const CLE_DESACTIVE = 'motrusse_textes';
const CLE_PASSES = 'motrusse_textes_passes';

// Une récompense qu'on subit n'est plus une récompense. Quelqu'un qui passe le
// texte trois fois d'affilée a déjà répondu à la question : on la lui pose une
// fois, puis on se tait.
export const PASSES_AVANT_PROPOSITION = 3;

export const textesDesactives = () => {
  try { return localStorage.getItem(CLE_DESACTIVE) === 'off'; }
  catch { return false; }
};

export const desactiverTextes = () => {
  try { localStorage.setItem(CLE_DESACTIVE, 'off'); } catch {}
};

export const reactiverTextes = () => {
  try {
    localStorage.removeItem(CLE_DESACTIVE);
    localStorage.removeItem(CLE_PASSES);
  } catch { /* stockage refusé : rien n'a pu être désactivé non plus */ }
};

export const passesDAffilee = () => {
  try { return parseInt(localStorage.getItem(CLE_PASSES) || '0', 10) || 0; }
  catch { return 0; }
};

export const noterPasse = () => {
  const n = passesDAffilee() + 1;
  try { localStorage.setItem(CLE_PASSES, String(n)); } catch {}
  return n;
};

// Une lecture remet le compteur à zéro : ce qu'on mesure, ce sont des passages
// D'AFFILÉE, pas un total qui finirait fatalement par atteindre trois.
export const noterLecture = () => {
  try { localStorage.setItem(CLE_PASSES, '0'); } catch {}
};
